import React from "react";
import Navbar from "../components/Navbar";
import Frequences from "../components/Frequences";
import Modules from "../components/Modules";
import Phase2 from "../components/Phase2";
import Testimonials from "../components/Testimonials";
import ProofWall from "../components/ProofWall";
import About from "../components/About";
import FaqFinal from "../components/FaqFinal";
import NormalHero from "../components/normal/NormalHero";
import NormalIntro from "../components/normal/NormalIntro";
import NormalExtra from "../components/normal/NormalExtra";
import NormalPricing from "../components/normal/NormalPricing";
import { BONUS } from "../mock";
import {
  TESTIMONIALS_N,
  VIDEO_TESTIMONIALS,
  SCREENSHOTS,
  ABOUT_N,
  FAQ_N,
} from "../data/mockNormal";

export default function NormalPage() {
  return (
    <>
      <Navbar promo={false} />
      <NormalHero />
      <NormalIntro />
      <Frequences />
      <NormalExtra />
      <Modules />
      <Phase2
        bonus={BONUS}
        bonusEyebrow="Bonus offerts"
        bonusTitle="3 bonus qui démultiplient"
        bonusHighlight="ton expérience"
        bonusCols="md:grid-cols-3"
      />
      <Testimonials items={TESTIMONIALS_N} videos={VIDEO_TESTIMONIALS} screenshots={SCREENSHOTS} />
      <ProofWall />
      <About about={ABOUT_N} />
      <NormalPricing />
      <FaqFinal faq={FAQ_N} />
    </>
  );
}
